export const updateResponses = (option, responses, setResponses, qnNum) => {
  const newResponses = responses.map((response, index) => {
    if (index === qnNum) {
      return {
        ...response,
        selected_options: option,
      };
    } else {
      return response;
    }
  });
  setResponses(newResponses);
};

// to hold product questions related helper functions
export const validateVariantQuestion = (selectedVariant, setSbOpen, snackbar, setSnackbar, pageNum, setPageNum) => {
  if (!selectedVariant || selectedVariant === "") {
    setSbOpen(true);
    setSnackbar({
      ...snackbar,
      message: "Please select 1 option!",
      severity: "warning",
      autoHideDuration: 5000,
    });
    return;
  }
  setPageNum(pageNum + 1);
};

// not in use
export const validateSelectQuestion = (value, required, setSbOpen, snackbar, setSnackbar, pageNum, setPageNum) => {
  if (!required) {
    setPageNum(pageNum + 1);
  } else {
    if (value.selected_options === undefined || value.selected_options.length === 0) {
      setSbOpen(true);
      setSnackbar({
        ...snackbar,
        message: "Please select 1 option",
        severity: "warning",
        autoHideDuration: 5000,
      });
      return;
    } else {
      setPageNum(pageNum + 1);
    }
  }
};

export const validateMultiSelectQuestion = (value, required) => {
  if (!required) {
    return true;
  }
  if (value.selected_options === undefined || value.selected_options.length === 0) {
    // setSbOpen(true);
    // setSnackbar({
    //   ...snackbar,
    //   message: "Please select at least 1 option",
    //   severity: "warning",
    //   autoHideDuration: 5000,
    // });
    return false;
  }
  return true;
};

export const validateShortAnswerQuestion = (value, required, setSbOpen, snackbar, setSnackbar, pageNum, setPageNum) => {
  if (!required) {
    return true;
  }
  if (value.selected_options === undefined || value.selected_options === "") {
    return false;
  }
  return true;
};
